module.exports = __webpack_public_path__ + "static/manticore-52b936ab2d278f0f4669bba8dd5eac61.jpeg";